<template>
  <section>
    <div id="subHeader" class="position-relative">
      <h1>Blog</h1>
      <h2>Fique atento</h2>
      <form class="search-container" @submit.prevent="performSearch">
        <input type="text" placeholder="Pesquisar..." v-model="searchQuery"/>
        <button type="submit">
          <i class="fa fa-search" aria-hidden="true"></i>
        </button>
      </form>
    </div>
    <div class="container-fluid" id="main">
      <div class="row">

        <div class="col-12 col-sm-12 col-md-8 col-xl-9 mb-5">
          <div class="row">
            <router-link :key="novidade.id" :to="{name: 'novidade', params: {id: novidade.id}}"
                         class="col-md-6 noticia p-3" v-for="novidade in novidades.data">
              <div class="card">
                <div class="card-body p-0">
                  <div class="row m-0">
                    <div class="col-4 col-md-12 col-xl-5 p-0">
                      <img alt="" class="p-0" :src="novidade.image">
                    </div>
                    <div class="col-8 col-md-12 col-xl-7 p-0 d-flex">
                      <div class="m-auto text-center">
                        <p class="p-3 m-0">{{ novidade.title }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer text-right">
                  <i class="fas fa-download"
                     v-if="novidade.documents && novidade.documents.length"></i>
                  <small>{{ moment(novidade.created_at).format('DD/MM/YYYY') }}</small>
                </div>
              </div>
            </router-link>
          </div>
        </div>

        <div class="col d-flex p-0" id="pager">
          <div class="m-auto">
            <div class="text-center pb-5">
              <h1>{{ novidades.current_page }}</h1>
              <h2>Página</h2>
            </div>
            <div class="text-center">
              <a @click.prevent="getResults(novidades.current_page - 1)" href="javascript:void(0)"
                 id="prev"
                 v-if="novidades.current_page > 1">
                <img alt="" src="/images/seta_tras.png">
                <button>Anterior</button>
              </a>
              <br>
              <a @click.prevent="getResults(novidades.current_page + 1)" href="javascript:void(0)"
                 id="next" v-if="novidades.current_page < novidades.last_page">
                <button>Próxima</button>
                <img alt="" src="/images/seta_tras.png">
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import moment from 'moment';

export default {
  name: "Novidades",
  metaInfo: {
    title: 'Blog',
  },
  data() {
    return {
      novidades: {current_page: 1, data: []},
      searchQuery: ''
    }
  },
  methods: {
    moment,
    performSearch() {
      this.getResults();
    },
    getResults(page = 1) {
      axios.post('/novidades', {page, search: this.searchQuery})
          .then(rsp => this.novidades = rsp.data)
    }
  },
  mounted() {
    this.$parent.image = '/images/novidades.jpg';
  },
  beforeRouteEnter(to, from, next) {
    axios.post('/novidades')
        .then(rsp => next(vm => vm.novidades = rsp.data))
  }
}
</script>

<style lang="scss" scoped>
.noticia {
  text-decoration: none;
  color: #fff;
}

.noticia:hover {
  text-decoration: none;
  color: lightgrey;
}

.noticia div {
  overflow: hidden;
}

.noticia:hover img {
  filter: grayscale(100%);
  width: 105%;
}

.noticia > .card:hover {
  background-color: rgba(0, 0, 0, .5);
}

.noticia img {
  height: 25vh;
  width: 100%;
  object-fit: cover;
  object-position: center;
}

.noticia > .card {
  background-color: rgba(0, 0, 0, .25);
  border-color: rgba(0, 0, 0, .6);
}

.noticia > .card > .card-footer {
  background-color: rgba(22, 29, 30, 1);
}

#pager h1 {
  font-size: 25vh;
  line-height: 19vh;
  color: #A8BCB3;
  font-family: Helvetica, serif !important;
  font-weight: bold !important;
}

#pager h2 {
  color: #A8BCB3;
  font-family: Helvetica, serif !important;
  font-weight: bold !important;
}

#pager #next,
#pager #prev {
  position: relative;
  display: inline-flex;

  > button {
    background: none;
    border: none;
    font-size: 1.6rem;
    height: 1.6rem;
    color: #fff;
    text-transform: uppercase;
    padding: 0 2rem;
    margin: auto 0;
  }

  > img {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 1.6rem;
    height: auto;
    margin: auto 0;
  }

}

#pager #next > img {
  transform: scaleX(-1);
  right: 0;
}

#pager #prev > img {
  left: 0;
}

.search-container {
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: end;
  margin: 15px 15px 55px;
  background-color: rgba(0, 0, 0, .25);
  border-color: rgba(0, 0, 0, .6);

  input {
    flex: 1;
    padding: 0.5rem;
    border: none;
    border-radius: 0;
    width: 45vw;
    min-width: 200px;
    max-width: 600px;
    background-color: transparent;
    color: #fff;
    margin: auto 0;
    font-size: 1rem;
    line-height: 1.5rem;
    position: relative;

    &:focus,
    &:active {
      background-color: rgba(0, 0, 0, .6);

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .6);
        filter: blur(2px); /* Adjust the blur value as needed */
        z-index: -1;
      }
    }
  }

  button {
    padding: 0.5rem;
    border: none;
    background-color: transparent;
    border-radius: 0 4px 4px 0;
    cursor: pointer;
    color: #fff;

    i {
      font-size: 1rem;
      line-height: 1.5rem;
    }
  }
}

@media screen and (max-width: 774px) {
  #pager {
    flex-grow: 1 !important;
  }
}
</style>